<template>
  <div style="padding-bottom: 50px;">
    <head-content :details="details" @refresh='getDetail' :reasonList='reasonList' :productIds='[productId]' />
    <base-content :details="details" />
    <box-content :rowId="productId" />
    <formula-additional-raw :rowId="productId" />
    <footer-content :shareId="shareId" :productId="productId" :formulaType="details.formulaType"
      :productName="details.productName" />
  </div>
</template>

<script>
import HeadContent from './modal/RecordHead.vue';
import BaseContent from './modal/RecordBase.vue';
import BoxContent from './modal/RecordBox.vue';
import FormulaAdditionalRaw from './modal/FormulaAdditionalRaw.vue';
import FooterContent from './modal/Footer.vue';
import { getRequest } from "@/components/Common/Utils/Utils.js";
export default {
  components: { HeadContent, BaseContent, BoxContent, FormulaAdditionalRaw, FooterContent },
  data() {
    return {
      details: {},
      shareId: getRequest('id'),
      reasonList: [],
      productId: getRequest('productId')
    };
  },
  mounted() {
    this.getDetail();
    this.getReasonList();
  },
  methods: {
    getReasonList() {
      this.$http.get('/iot-system/dict/list?code=ebs_reason').then(res => {
        let { success, data } = res || {};
        if (success) {
          let list = [];
          let reasonObj = {};
          if (data && data[0]) {
            let obj = data[0] || {};
            if (obj.children) {
              list = obj.children || [];
              list.forEach(el => {
                reasonObj[el.dictKey] = el.dictValue || '';
              });
              this.reasonObj = reasonObj || {};
            }
          }
          this.reasonList = list || [];
        } else {
          this.reasonObj = {};
          this.reasonList = [];
        }
      });
    },
    getDetail() {
      this.$http.get('/nhf-app/formulaproduct/getFormulaProductDetailById', { params: { id: this.productId } }).then(res => {
        if (res && res.data) {
          this.details = res.data;
        }
      });
    },
  }
};
</script>
<style lang="scss" scoped>
.footer-content {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 0 20px;
  height: 50px;
  position: absolute;
  bottom: 0;
  left: 10px;
  right: 22px;
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
  background-color: #fff;
  border-top: 1px solid #e8e8e8;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
}
</style>
